import { create } from 'zustand';

import { fileFormatKind } from '@shared/lib/file-format';

import type { AttachmentPolicy } from '../types';

import { ACCEPTED_FILE_TYPES, MAX_ATTACHMENT_BYTES, MAX_ATTACHMENTS } from './attachments';

export function policyFromAccept(
  accept: string,
  maxBytes: number,
  maxFiles: number,
): AttachmentPolicy {
  const extensions = accept
    .split(',')
    .map((type) => type.trim().replace(/^\./, '').toLowerCase())
    .filter((extension) => extension !== '');
  return {
    accept,
    extensions,
    maxBytes,
    maxFiles,
    acceptsAudio: extensions.some((extension) => fileFormatKind(extension) === 'audio'),
  };
}

export const DEFAULT_ATTACHMENT_POLICY: AttachmentPolicy = policyFromAccept(
  ACCEPTED_FILE_TYPES,
  MAX_ATTACHMENT_BYTES,
  MAX_ATTACHMENTS,
);

export const DESIGN_ATTACHMENT_POLICY: AttachmentPolicy = policyFromAccept(
  `${ACCEPTED_FILE_TYPES},.doc,.ppt,.webp,.heic,.md,.json,.xml,.mp3,.m4a,.wav`,
  50 * 1024 * 1024,
  MAX_ATTACHMENTS,
);

const useAttachmentPolicyStore = create<{ policy: AttachmentPolicy }>()(() => ({
  policy: DEFAULT_ATTACHMENT_POLICY,
}));

export function getAttachmentPolicy(): AttachmentPolicy {
  return useAttachmentPolicyStore.getState().policy;
}

export function setAttachmentPolicy(policy: AttachmentPolicy): void {
  useAttachmentPolicyStore.setState({ policy });
}

export function useAttachmentPolicy(): AttachmentPolicy {
  return useAttachmentPolicyStore((state) => state.policy);
}
